import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://yjejxqdgnoklysuuwvaj.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlqZWp4cWRnbm9rbHlzdXV3dmFqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA0MTE3MTUsImV4cCI6MjA5NTk4NzcxNX0.DKgNlTVuE4kCHpSj70KvgbP6A9QZiWI-flwbY3vbr-Q'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})